// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__reNk2","label":"SetPasswdForm_label__3seZs"};